import { useQuery } from '@tanstack/react-query'
import apiClient from '@/services/apiClient'

export interface TipoEspacio {
  id: string
  nombre: string
  descripcion?: string
  tarifa_base_tipo: number
  unidad_reserva: string  // 'dia' o 'noche'
  privado?: boolean  // Si es privado (solo admin) o público (sitio web)
  imagen?: string | null  // Ruta de la imagen del tipo
  reservable?: boolean  // Si se puede reservar
}

export const useTiposPublicos = () => {
  return useQuery({
    queryKey: ['tipos-espacios-publicos'],
    queryFn: async () => {
      const response = await apiClient.get<TipoEspacio[]>('/api/espacios/tipos')
      return response.data
    },
    staleTime: 30 * 60 * 1000, // 30 minutos
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })
}
